import React from 'react';
import styled from 'styled-components';
import { media } from '../../utils/style';
import H1 from '../H1';
import H3 from '../H3';
import P from '../P';
import Project from './Project';
import ProjectWithNoImage from './ProjectWithNoImage';
import CompareMoviesLogo from '../../images/compare-movies.jpg';
import NagMeLogo from '../../images/nag-me.jpg';
import ReactShortenLogo from '../../images/react.png';

const Headings = styled.div`
  padding: ${props => (props.projectPage ? '0 10px 20px' : '40px 10px 20px')};
  text-align: center;
`;

const Projects = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 25px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
  width: 100%;

  ${media.desktop`
    flex-wrap: nowrap;
  `};
`;

export default ({ projectPage }) => (
  <div>
    <Headings projectPage={projectPage}>
      {projectPage ? <H1 bigger>Projects</H1> : <H3 bigger>Projects</H3>}
      <P bigger>A collection of my open-source works and recent projects</P>
    </Headings>

    <Projects>
      <ProjectWithNoImage
        link="/projects/react-shorten"
        title="React Shorten"
        description="React component to shorten text"
        image={ReactShortenLogo}
      />
      <Project
        link="/projects/compare-movies"
        title="Compare Movies"
        description="Compare Movies and TV Shows Instantly"
        image={CompareMoviesLogo}
      />
      <Project
        portrait
        link="/projects/nag-me"
        title="Nag Me"
        description="Browser extension to nag users"
        image={NagMeLogo}
      />
    </Projects>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/ProjectComponents/index.js